import React from 'react';
import type { SelectEntityOptionProps } from '../../components/SelectEntityOption';
import SelectEntityOption from '../../components/SelectEntityOption';
import SVGIcon from '../../components/SVGIcon';
import addIcon from '../../icons/add.svg';
import styles from './NewSelectOption.module.scss';

export interface NewSelectOptionProps extends SelectEntityOptionProps {
  label: React.ReactNode;
  secondary?: React.ReactNode;
}

const NewSelectOption = (props: NewSelectOptionProps) => (
  <SelectEntityOption
    icon={
      <div className={styles.newIconContainer}>
        <SVGIcon>{addIcon}</SVGIcon>
      </div>
    }
    {...props}
  />
);

export default NewSelectOption;
